import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management.edit', {
        url: '/edit/:slmiId',
        component: 'companySoftwareLicenseManagementEdit',
        resolve: {
            $breadcrumbs,
            slmi
        },
    });
}

/** @ngInject */
function slmi(softwareLicenseManagementInfos, $stateParams) {
    return softwareLicenseManagementInfos.find(slmi => slmi.id === $stateParams.slmiId);
}

/** @ngInject */
function $breadcrumbs(slmi) {
    if(slmi == null) {
        return;
    }
    const title = {
        // getter to allow dynamic updates
        get title() {
            return slmi.application.applicationName;
        }
    };

    return [title];

}



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/edit/software-license-management-edit.state.js